import type { GetCustomRibbonAuditByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetCustomRibbonAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomRibbonAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCustomRibbonAuditByIdArgs = {
  id: string;
};

export const useGetCustomRibbonAuditById = createQueryHook<
  UseGetCustomRibbonAuditByIdArgs,
  GetCustomRibbonAuditByIdResponseRow[],
  GetCustomRibbonAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.customRibbon.auditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    custom_ribbon_audit: data ?? [],
  }),
  graphqlDocument: GetCustomRibbonAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
